<header>
  <div class="app-icon"></div>
  <h2>Sierra Asset</h2>
</header>
